import { animated } from '@react-spring/web';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        background: var(--bg-color, ${theme.colors.secondary.tints[1].hex});
        overflow: hidden;
        padding: 0 0 1.5rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem 0;
        }
    `}
`;

export const InformationBlocks = styled(animated.div)`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
        }
    `}
`;

export const Spacer = styled.div`
    ${({ theme }) => css`
        border-left: 0.1rem solid ${theme.colors.secondary.tints[1].hex};
        margin-bottom: 1rem;

        @media ${({ theme }) => theme.breakpoints.medium.media} {
            margin-bottom: inherit;
        }
    `}
`;
